export default __webpack_public_path__ + "276638c89a2ece7d8ff72e3e43c9d2a7.png";